'use strict';

module.exports = require('./dist/zh-address-parse.min');
